// extracted by mini-css-extract-plugin
export default {"root":"Uzn3FzQ8TcR36pBlW6oW","placeHolderShimmer":"t_EtDan9sVDT_GQ0Hj7I"};